
import allImgPaths from "../../../assets/images";
import MessagesModifier from "./MessagesModifier";
import ReviewSpace from "components/reviewspace/ReviewSpace";
import useAppState from "context/useAppState";
import ReactMarkdown from 'react-markdown';
import PlaceholderLoader from "./PlaceholderLoader";
import React, { useEffect, useRef, useState } from "react";
import { extractJSONFromText, getTimeForChatMessage, removeIntents, removeJSONFromString } from "utils/function";
import { LLM_INTENTS } from "utils/constant";
import ListItems from "./ListItems";
import ImageCardContainer from "./ImageCardContainer";
import { has } from "lodash";
import Rfp from "components/rfp/Rfp";
import EventProgram from "components/event-program/EventProgram";
import EmailTemplate from "components/email-template/EmailTemplate";
import BudgetAllocation from "./BudgetAllocation";
import RfpCompare from "components/rfp/RfpCompare";
import ViewListItem from "components/ViewListItems";
import RfpSummary from "components/rfp/RfpSummary";

const ChatMessages = () => {

    const containerRef = useRef<any>(null);
    const { showChatLoader, messageHistory } = useAppState('chatMessages');

    const userDetails = JSON.parse(localStorage.getItem('userData') as string);

    const scrollToBottom = () => {
        // Scroll to the bottom of the container
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        scrollToBottom();
    }, [showChatLoader]);

    const getFilteredFeteBuddyMessage = (message: string) => {
        let filteredMessage = removeIntents(message).trim();
        const jsonOb = extractJSONFromText(message);
        if (message.startsWith('{') && message.endsWith('}')) {
            return null;
        }
        if (jsonOb && Object.keys(jsonOb).length > 0) {
            filteredMessage = removeJSONFromString(message);
        }
        return filteredMessage;
    }

    const getUserMessage = (messageObj: any) => {
        return (
            // User Message 
            <div className="user-msg last:mb-0 mb-4 pb-3">
                <div className="w-full flex gap-x-3">
                    <img className="w-10 h-10 rounded-full" src={userDetails?.profile_image || allImgPaths.defaultProfile} alt="" />
                    <div>
                        <div className="flex items-center gap-x-3 mb-1">
                            <span className="text-sm font-interMedium text-[#344054]">You</span>
                            <span className="text-xs text-[#475467]">{getTimeForChatMessage(messageObj?.createdAt)}</span>
                        </div>
                        <div className="bg-[#F9FAFB] rounded-lg px-3.5 py-2.5 border border-[#EAECF0]">
                            <p className="text-[#101828] text-base leading-[1.4]">{messageObj?.content}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const isIncludesJSON = (message: string) => {
        let isIncludesJSONObj = false;
        const jsonOb = extractJSONFromText(message);
        if (jsonOb && Object.keys(jsonOb).length > 0) {
            isIncludesJSONObj = true;
        }
        return isIncludesJSONObj;
    }

    const shouldRenderImagesComponent = (jsonObj: any) => {
        return jsonObj?.renderImages || false
    }

    // FeteBuddy Messages
    const getFeteBuddyMessage = (messageObj: any) => {
        const isJSON = isIncludesJSON(messageObj?.content);
        if (!isJSON && getFilteredFeteBuddyMessage(messageObj?.content)) {
            return (
                <div className="fete-msg mb-4 last:mb-0 pb-3">
                    <div className="w-full flex gap-x-3">
                        <img className="w-10 h-10" src={allImgPaths.fetebuddyGradientIcon} alt="" />
                        <div>
                            <div className="flex items-center gap-x-3 mb-1">
                                <span className="text-sm font-interMedium text-[#344054]">Fete Buddy</span>
                                <span className="text-xs text-[#475467]">{getTimeForChatMessage(messageObj?.createdAt)}</span>
                            </div>
                            <div className="bg-[#F9FAFB] rounded-lg px-3.5 py-2.5 border border-[#EAECF0]">
                                <p className="text-[#101828] text-base leading-[1.4]">
                                    <ReactMarkdown>
                                        {getFilteredFeteBuddyMessage(messageObj?.content)}
                                    </ReactMarkdown>
                                </p>
                            </div>
                            {/* <MessagesModifier /> */}
                        </div>
                    </div>
                </div>
            )
        }
        const extractedData: any = extractJSONFromText(messageObj?.content);
        if (has(extractedData, "items")) {
            // Render list of there is object
            if (extractedData?.renderImages) {
                return (
                    <ImageCardContainer messageData={messageObj} />
                )
            } else {
                return (
                    <ListItems messageData={messageObj} />
                )
            }
        }
        if (has(extractedData, 'isRichTextContent') && extractedData?.['isRichTextContent']) {
            return (
                // <RichTextEditorContainer messageData={messageObj} />
                <EventProgram messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isEmailContent') && extractedData?.['isEmailContent']) {
            return (
                // <EmailContainer messageData={messageObj} />
                <EmailTemplate messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isBudgetAllocation') && extractedData?.['isBudgetAllocation']) {
            return (
                <BudgetAllocation messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isRFP') && extractedData?.['isRFP']) {
            return (
                <Rfp messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isRFPComparison') && extractedData?.['isRFPComparison']) {
            return (
                <RfpCompare messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isRFPSummary') && extractedData?.['isRFPSummary']) {
            return (
                <RfpSummary messageData={messageObj} />
            )
        }
        if (has(extractedData, 'isViewListItem') && extractedData?.['isViewListItem']) {
            return (
                <ViewListItem messageData={messageObj} />
            )
        }
    }

    const shouldIgnoreMessage = (msg: any) => {
        let shouldIgnore = false;
        // Object.keys(DEFAULT_FETEBUDDY_INITIATE_MESSAGES).map((key: any) => {
        //     if(DEFAULT_FETEBUDDY_INITIATE_MESSAGES[key] === msg?.content) {
        //         shouldIgnore = true;
        //     }
        // })
        return shouldIgnore;
    }

    return (
        <>
            <div className="h-full flex flex-col justify-end fetebuddy-screen">

                <div
                    ref={containerRef}
                    className="py-2 overflow-y-auto pr-1"
                >
                    {messageHistory && messageHistory.length > 0 && messageHistory.map((message: any, messageIndex: number) => {
                        // if(!shouldIgnoreMessage(message)) {
                        if (message.type.toLowerCase() === 'human') {
                            return (
                                <React.Fragment key={messageIndex}>
                                    {getUserMessage(message)}
                                </React.Fragment>
                            )
                        } else {
                            return (
                                <React.Fragment key={messageIndex}>
                                    {getFeteBuddyMessage(message)}
                                </React.Fragment>
                            )
                        }
                        // }
                    })}
                    {showChatLoader && (
                        <PlaceholderLoader />
                    )}
                </div>

            </div>

            {/* Review Space */}
            <ReviewSpace />
        </>
    )
}

export default React.memo(ChatMessages);